import React, { useContext } from 'react';
import {
  Button,
  Header,
} from '@a-ui/react';

import UserContext from 'contexts/User';
import { getEnvironment } from 'helpers/environment';

const env = getEnvironment();

const loginUrl = env === 'local' ? 'http://localhost:2000/auth/login' : '/auth/login';
const logoutUrl = env === 'local' ? 'http://localhost:2000/auth/logout' : '/auth/logout';
const STORAGE_KEY = 'sorteerpasopladen_initialLogin';

const AppHeader = () => {
  const session = useContext(UserContext);
  const fromUrl = env === 'local' ? 'http://localhost:3000' : window.location.href;

  const login = () => {
    localStorage.setItem(STORAGE_KEY, true);
    window.location.href = `${loginUrl}?fromUrl=${fromUrl}`;
  };

  const logout = () => {
    localStorage.setItem(STORAGE_KEY, false);
    window.location.href = `${logoutUrl}?fromUrl=${fromUrl}`;
  };

  const menuItems = session.isLoggedIn ? [{
    addOn: {
      avatarProps: {
        image: session.user.avatarUrl,
      },
      type: 'avatar',
    },
    flyout: {
      children: <Button
        onClick={logout}
        theme="danger"
      >
        Uitloggen
      </Button>,
      orientation: 'bottom-right',
    },
    label: `${session.user.firstName} ${session.user.lastName}`,
  }] : [{
    label: 'Inloggen',
    onClick: login,
  }];


  return (
    <React.Fragment>
      <Header
        menuItems={menuItems}
      />
    </React.Fragment>
  );
}

export default AppHeader;